import React, { CSSProperties, FunctionComponent } from 'react'
import styles from './DoubleSwitch.module.sass'
import clsx from 'clsx'
import { Classes } from '../../../styles'
import { lighten } from 'polished'

interface Props {
    className?: string,
    value: boolean,
    onChange: (value: boolean) => void,
    disabled?: boolean,
    left: string,
    right: string,
    leftColor: string,
    rightColor: string,
    notification?: boolean
}

const DoubleSwitch: FunctionComponent<Props> = props => {
    const currentColor = props.value ? props.rightColor : props.leftColor
    return <div
        className={clsx(props.className, styles.switch, Classes.touchTarget, {[styles.disabled]: props.disabled})}
        onClick={() => !props.disabled && props.onChange(!props.value)}
        style={{
            '--color': currentColor,
            '--hover': lighten(0.03, currentColor)
        } as CSSProperties}
    >
        <div
            className={clsx(styles.content, {[styles.active]: !props.value})}
            data-text={props.left}
            style={{color: props.leftColor}}
        >
            {props.left}
        </div>
        <div className={clsx(
            styles.element,
            {[styles.notification]: props.notification},
            {[styles.active]: props.value}
        )}/>
        <div
            className={clsx(styles.content, {[styles.active]: props.value})}
            data-text={props.right}
            style={{color: props.rightColor}}
        >
            {props.right}
        </div>
    </div>
}

export default DoubleSwitch